import { useObservable } from '@/core/U';
import { NodeItem, NodeType } from './NodeItem';
import { Edge, Node } from '@xyflow/react';
import { useEffect } from 'react';
import { BehaviorSubject } from 'rxjs';
import { NodeViewDirector } from './NodeViewDirector';

export function useReactFlowNodeAndEdge(
  director: NodeViewDirector,
  callback: (nodes: Node[], edges: Edge[]) => void,
) {
  const nodeItems = useObservable(director.data.nodes);
  const nodeForcus = useObservable(director.data.focusNodes);

  useEffect(() => {
    // node 변환
    const nodes = nodeItems
      .filter((n) => n.visible)
      .map(
        (n) =>
          ({
            id: String(n.id),
            position: { x: n.x, y: n.y },
            type: 'custom',
            data: n.toJSON(),
          } as Node),
      );

    // edge Active 처리
    const activeEdges: string[] = [];
    const visitedNodes = new Set<number>();
    const recursive = (node: NodeItem) => {
      // 이미 방문한 노드면 중단 (순환 참조 방지)
      if (visitedNodes.has(node.id)) {
        return;
      }
      // 노드 방문목록에 추가
      visitedNodes.add(node.id);
      node.source.forEach((src_id) => {
        const srcNode = director.data.nodes.value.find((n) => n.id === src_id);
        if (srcNode) {
          activeEdges.push(`${srcNode.id}-${node.id}`);
          recursive(srcNode);
        }
      });
    };
    if (nodeForcus) {
      nodeForcus.map((node) => recursive(node));
    }
    // if (nodeForcus) {
    //   recursive(nodeForcus);
    // }

    // edge 변환
    const edges: Edge[] = [];
    nodeItems
      .filter((n) => n.visible)
      .forEach((n) => {
        n.target.forEach((t_id) => {
          const target = director.data.nodes.value.find((n) => n.id === t_id);
          if (target?.visible && target?.type !== NodeType.PALETTE) {
            const edge_id = `${n.id}-${target.id}`;
            edges.push({
              id: edge_id,
              type: 'custom',
              data: { edgeStyle: activeEdges.indexOf(edge_id) === -1 ? 'inactive' : 'active' },
              source: String(n.id),
              target: String(target.id),
            });
          }
        });
      });
    callback(nodes, edges);
  }, [nodeItems, nodeForcus]);
}

let NodeViewDirectorlSubject: BehaviorSubject<NodeViewDirector>;
export function useNodeViewModelProvide(director?: NodeViewDirector) {
  useEffect(() => {
    if (director) {
      if (NodeViewDirectorlSubject === undefined) {
        NodeViewDirectorlSubject = new BehaviorSubject(director);
      } else {
        NodeViewDirectorlSubject.next(director);
      }
    }
  }, [director]);
}

export function useNodeViewModel() {
  return useObservable(NodeViewDirectorlSubject);
}
